import { apiClientAuth } from "../config/httpClient";


export function SubscriptionApi(contentType = "application/json")
{
    // const http = apiClient(contentType);
    const https = apiClientAuth(contentType);

    return {

        insert : (uid, data) => https.post(`/api/subscription/${uid}`, data),

        // findOne: (id) => https.get(`/api/message/${id}`),

        // findAll: () => https.get(`/api/message`),


      };
}

